// test2260
(2260 && 0);
